import React, { useState } from 'react';

const LOGIN_PIN = '198217';

const LoginPage: React.FC<{ onLogin: () => void }> = ({ onLogin }) => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    setTimeout(() => {
      if (pin === LOGIN_PIN) {
        localStorage.setItem('launchpad_auth', 'true');
        onLogin();
      } else {
        setError('Invalid PIN. Access denied.');
        setPin('');
      }
      setLoading(false);
    }, 400);
  };

  return (
    <div className="min-h-screen bg-[#0f172a] flex items-center justify-center p-4">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      </div>

      <div className="relative bg-[#1e293b] border border-slate-700 rounded-2xl shadow-2xl p-8 w-full max-w-sm">
        {/* Shield icon */}
        <div className="text-center mb-6">
          <div className="w-14 h-14 rounded-xl bg-[#0f172a] border border-slate-600 flex items-center justify-center mx-auto mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
          </div>
          <h1 className="text-lg font-bold text-white tracking-tight">Vidhiguru Launchpad</h1>
          <p className="text-xs text-slate-400 mt-1">Secure Access • Digital Curator</p>
        </div>

        {/* PIN Form */}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider block mb-2">Access PIN</label>
            <input
              type="password"
              inputMode="numeric"
              maxLength={6}
              value={pin}
              onChange={e => { setPin(e.target.value.replace(/\D/g, '')); setError(''); }}
              placeholder="• • • • • •"
              className="w-full text-center text-xl tracking-[0.5em] font-mono px-4 py-4 bg-[#0f172a] border-2 border-slate-600 rounded-xl text-white placeholder-slate-600 focus:outline-none focus:border-blue-500 transition-colors"
              autoFocus
            />
          </div>

          {error && (
            <div className="text-center text-xs text-red-400 mb-3 font-medium flex items-center justify-center gap-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={pin.length !== 6 || loading}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-semibold text-sm disabled:opacity-40 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2"
          >
            {loading ? (
              <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            )}
            {loading ? 'Verifying...' : 'Unlock'}
          </button>
        </form>

        <p className="text-center text-[9px] text-slate-500 mt-6">
          Authorized Personnel Only • Monitored Access
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
